export class JsonHelper {
    public static deepCopy<T>(obj: T): T {
        return structuredClone(obj);
    }
}
